module.exports = __webpack_public_path__ + "img/cloth_g3_item-03.2157d935.svg";